// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"20e8d6f6","451":"21f49d1e","453":"37cadd21"}[chunkId] + ".chunk.js";
};